import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../models/user.model';
import { EventModel } from '../models/event-model.model';

@Injectable()
export class EventService extends BaseService {

  protected makeModel(data: any): EventModel {
    if(!data.camera) {
      data.camera = {};
    }
    return new EventModel(data);
  }

  public index(): Observable<EventModel[]> {
    return this.http.get(this.url('events'), this.getRequestOptions())
      .map(this.extractData)
      .map(this.mapResourceData)
      .catch(this.handleError);
  }

  public store(event: EventModel) {
    return this.http.post(this.url('events'), event, this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public destroy(event: EventModel) {
    return this.http.delete(this.url(`events/${event._id}`), this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public update(event: EventModel) {
    return this.http.put(this.url(`events/${event._id}`), event, this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public updateOrStore(event: EventModel, isUpdate = true) {
    if (isUpdate) {
      return this.update(event);
    } else {
      return this.store(event);
    }
  }

  public show(_id) {
    return this.http.get(this.url(`events/${_id}`), this.getRequestOptions())
      .map(this.extractData)
      .map(this.mapResourceData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/services/event.service.ts